import gsap from "gsap";

export class HeroAnimation {
	constructor() {
		this.hero = document.querySelector(".hero");
		this.isMobile = window.matchMedia("(max-width: 1000px)").matches;

		if (!this.hero || !this.isMobile) return;

		this.init();
	}

	init() {
		const heroLogo = this.hero.querySelector(".hero__logo");
		if (!heroLogo) return;

		const heroLogoWords = heroLogo.querySelectorAll(".logo__word");
		if (!heroLogoWords.length) return;

		this.animateLogoWords(heroLogoWords);
	}

	animateLogoWords(logoWords) {
		gsap.from(logoWords, {
			autoAlpha: 0,
			duration: 0.01,
			stagger: 0.5,
			delay: 0.5,
		});
	}
}
